import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Group_6195"
      data-name="Group 6195"
      width={17.223}
      height={17.223}
      {...props}>
      <defs>
        <style>{'.cls-1{fill:#fff;opacity:.9}'}</style>
      </defs>
      <path
        id="Path_7604"
        data-name="Path 7604"
        className="cls-1"
        d="M-.572-12.141a1.276 1.276 0 0 1-.9-.326 1.057 1.057 0 0 1-.351-.806 1.071 1.071 0 0 1 .351-.818 1.276 1.276 0 0 1 .9-.326 1.259 1.259 0 0 1 .892.326 1.071 1.071 0 0 1 .351.818 1.057 1.057 0 0 1-.351.806 1.259 1.259 0 0 1-.892.326Zm1.046.714v6.868h-2.1v-6.868Z"
        transform="translate(9.29 17.863)"
      />
      <path
        id="Ellipse_180"
        data-name="Ellipse 180"
        className="cls-1"
        d="M8.611 1.148a7.463 7.463 0 0 0-5.277 12.741A7.463 7.463 0 0 0 13.889 3.334a7.414 7.414 0 0 0-5.278-2.186m0-1.148A8.611 8.611 0 1 1 0 8.611 8.611 8.611 0 0 1 8.611 0Z"
      />
    </svg>
  );
}

export default SvgComponent;
